import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { APIConfig } from 'src/app/api';
import { throwError } from 'rxjs';
import { makeHttpParams } from './utils';

export interface ShippingServiceSearchOptions {
  cep: string;
  valorDeclarado?: number;
  dimensions?: {
    peso: number;
    altura: number;
    largura: number;
    comprimento: number;
  };
}

export interface ShippingService {
  codigo: string;
  nomeExibicao: string;
  nomeFormatado: string;
  prazoConhecido: boolean;
  disponivel: boolean;
  preco?: number;
  prazoMaximo?: number;
  prazoMinimo?: number;
  dataChegada?: number;
  dataChegadaFormatada?: string;
  indicadorPreco: number;
  valorDeclaradoMinimo: number;
  valorDeclaradoMaximo: number;
  percentualValorDeclarado: number;
  listaPadraoValoresDeclarados: number[];
  dataPostagem: number;
  dataPostagemFinal: number;
}

export interface ShippingServiceSearchResponse {
  dataPostagem: number;
  mensagemPostagem: string;
  observacao?: string;
  inidicadorPrecoMaximo: number;
  opcoes: ShippingService[];
}

@Injectable({
  providedIn: 'root'
})
export class ShippingServiceApiService {
  constructor(private http: HttpClient, private config: APIConfig) { }

  /**
   * Retrieve shipping service information
   */
  public getOptions(options: ShippingServiceSearchOptions) {
    if (!options.cep || !/\d{5}-?\d{3}/.test(options.cep)) {
      return throwError(new Error('Invalid CEP'));
    }

    let data = { cep: options.cep, valorDeclarado: null };
    if (options.dimensions) {
      data = { ...data, ...options.dimensions };
    }
    if (options.valorDeclarado || options.valorDeclarado !== null) {
      data.valorDeclarado = options.valorDeclarado;
    }

    const token = localStorage.getItem('ls.token').replace(/"/g, '');
    if (token) {
      const headers = new HttpHeaders({
        'Authorization': token,
      });

    return this.http.get<ShippingServiceSearchResponse>(`${this.config.pedidoApiUrl}/v2/opcoes/`, {
        headers,
        params: makeHttpParams(data),
      });
    }
  }
}
